import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
   
    appinfo: {
      // token: '6szlhon7s346pnpk3c5oumcwkhv22rbrpz0aa3if',
      // course_id: 2
    },
    loginInfo:{
        access_token:'',
        uid:''
    },
    userInfo:{
      profile_image_url:'',
      nickname:'',
      appadmin:'',
    },
    order_info: {},
    
    pledge: {
      musicPlaying: true
    },
    globalInfo:{}
  },
  mutations: {
    setAppInfo(state, obj){
      state.appinfo = Object.assign(state.appinfo, obj)
    },
    setLoginInfo(state,obj){
        state.loginInfo = obj
    },
    setUserInfo(state,obj){
        state.userInfo = obj
    },
    setGlobalInfo(state,obj){
      state.globalInfo = obj
    }
  },
  getters:{
    loginInfo: (state) => state.loginInfo,
    userInfo: (state) => state.userInfo,
    globalInfo: (state) => state.globalInfo,
  },
  actions: {
  }
})
